// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<div id="customer-deposit-accounts-close-account" class="box product-operation">
  <sub-header header="\$ctrl.pageHeader"></sub-header>
    <form name="\$ctrl.form">
      <form-section>

        <div class="info info--deposit">
          <div class="info__field">
            <span class="info__field-label">Product name:</span>
            <span class="info__field-value">
              {{\$ctrl.depositAccount.productName}}
            </span>
          </div>

          <div class="info__field">
            <span class="info__field-label">Available balance:</span>
            <span class="info__field-value"
                  ng-class="{'currency--positive': \$ctrl.depositAccount.balance > 0, 'currency--negative': \$ctrl.depositAccount.balance < 0}">
              {{\$ctrl.depositAccount.balance | nxCurrency}}
            </span>
          </div>
        </div>

        <h2 class="section-header">Please confirm the following:</h2>
        <table class="misc-transaction__table table table--generate-row-ids">
          <tbody>
          <tr>
            <td></td>
            <td>Gross interest</td>
            <td>
              <cash ng-model="\$ctrl.interestForecast.interest"
                    ng-disabled="true"
                    ng-required="true"></cash>
            </td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td>Withholding tax</td>
            <td>
              <cash ng-model="\$ctrl.interestForecast.withholdingTax"
                    ng-disabled="true"
                    ng-required="true"></cash>
            </td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td>Net interest</td>
            <td>
              <cash ng-model="\$ctrl.interestForecast.netInterest"
                    ng-disabled="true"
                    ng-required="true"></cash>
            </td>
            <td></td>
          </tr>
          <tr ng-repeat="fee in \$ctrl.interestForecast.terminationFees">
            <td></td>
            <td>{{fee.name}}</td>
            <td>
              <cash ng-model="fee.amount" ng-disabled="!fee.override" ng-change="\$ctrl.terminationFeeChanged()"></cash>
            </td>
            <td>
              <label class="checkbox misc-transaction__table-checkbox">
                <input
                  type="checkbox"
                  ng-model="fee.override"
                  ng-change="\$ctrl.changeFeeOverride(fee)"
                />
                Override
              </label>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>Withdrawal amount</td>
            <td>
              <cash ng-model="\$ctrl.command.amount"
                    ng-disabled="true"
                    ng-required="true"></cash>
            </td>
            <td></td>
          </tr>
          <tr ng-if="\$ctrl.mode === 'CloseWithCheck'">
            <td></td>
            <td>Check number</td>
            <td>
              <input
                required
                type="text"
                class="check-no"
                ng-model="\$ctrl.command.checkNumber"
                ng-change="\$ctrl.updateMicr()"
                ui-mask="9999999999"
                ng-minlength="10"
                ng-maxlength="10"/>
            </td>
            <td></td>
          </tr>
          <tr ng-if="\$ctrl.mode === 'CloseWithCheck'">
            <td></td>
            <td>Check account:</td>
            <td>
              <selectize
                options="\$ctrl.checkingAccounts"
                config="\$ctrl.selectConfig"
                ng-model="\$ctrl.command.depositoryAccountId"
                ng-change="\$ctrl.updateMicr()"
                ng-required="true">
              </selectize>
            </td>
            <td></td>
          </tr>
          <tr ng-if="\$ctrl.mode === 'CloseWithCheckEncash'">
            <td></td>
            <td>MICR number</td>
            <td>
              <input
                required
                type="text"
                class="check-no"
                ng-model="\$ctrl.command.micrNumber"
                ui-mask="&#x2448;9999999999&#x2448;99999&#x2449;9999&#x2446;999999999999&#x2448;"
                ui-mask-placeholder
                ui-options="{clearOnBlur: false}"
                ng-change="\$ctrl.onMicrNumberChange(\$ctrl.command.micrNumber)"
                maxlength="64"/>
            </td>
            <td></td>
          </tr>
          <tr ng-if="\$ctrl.mode === 'CloseWithCheckEncash' || \$ctrl.mode === 'CloseWithCheck'">
            <td></td>
            <td>Valid from</td>
            <td>
              <date ng-model="\$ctrl.command.validFrom"
                    ng-required="true"></date>
            </td>
            <td></td>
          </tr>
          <tr ng-if="\$ctrl.mode === 'CloseWithCheckEncash' || \$ctrl.mode === 'CloseWithCheck'">
            <td></td>
            <td>Remarks</td>
            <td>
              <input
                type="text"
                ng-model="\$ctrl.command.remarks"
                ng-required="false">
            </td>
            <td></td>
          </tr>
          </tbody>
        </table>
        <div class="buttons">
          <signature-card
            file-id="\$ctrl.depositAccount.signatureCardFileId"
            product-group="'ACCOUNT'"
            product-status="\$ctrl.depositAccount.status"></signature-card>
          <button type="button"
                  class="btn btn-warning"
                  ng-click="\$ctrl.redirectBack()">Cancel</button>
          <button type="submit"
                  class="btn btn-success"
                  ng-click="\$ctrl.close()"
                  ng-disabled="\$ctrl.form.\$invalid">Close</button>
        </div>

        <div class="clearfix"></div>
      </form-section>
    </form>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/close-account/close-account.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;